import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class CatalogueViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getCatalogues = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (
      Format.isNotNull(catalogueResponse.errorCode) &&
      catalogueResponse.errorCode === 0
    ) {
      if (Format.isNotNull(catalogueResponse.catalogueList)) {
        catalogueResponse.catalogueList.forEach(async element => {
          element.categoryList = await this.getCategorys(element.id);
        });

        this.updateState("catalogueList", catalogueResponse.catalogueList);
        this.logger.info(catalogueResponse.catalogueList);
      } else {
        this.showEmpty("Catalogue");
      }
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      categoryResponse.categoryList.forEach(element => {
        element.crudlState = CrudlStatus.UPDATE;
      });
      return categoryResponse.categoryList;
    } else {
      return [];
    }
  };

  getCataloguesReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (
      Format.isNotNull(catalogueResponse.errorCode) &&
      catalogueResponse.errorCode === 0
    ) {
      if (Format.isNotNull(catalogueResponse.catalogueList)) {
        catalogueResponse.catalogueList.forEach(async element => {
          element.categoryList = await this.getCategorys(element.id);
        });

        this.logger.info(catalogueResponse.catalogueList);
        return catalogueResponse.catalogueList;
      } else {
        this.showEmpty("Catalogue");
      }
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  createCategory = async categoryRequest => {
    categoryRequest.codeTag = this.codeTag;
    categoryRequest.userId = this.userId;

    let categoryResponse = await ApiService.categoryCreate(categoryRequest);
    if (categoryResponse.errorCode === 0) {
      return categoryResponse;
    } else {
      return categoryResponse;
    }
  };
  updateCategory = async categoryRequest => {
    categoryRequest.codeTag = this.codeTag;
    categoryRequest.userId = this.userId;

    let categoryResponse = await ApiService.categoryUpdate(categoryRequest);
    if (categoryResponse.errorCode === 0) {
      return categoryResponse;
    } else {
      return categoryResponse;
    }
  };
  deleteCategory = async categoryRequest => {
    categoryRequest.codeTag = this.codeTag;
    categoryRequest.userId = this.userId;

    let categoryResponse = await ApiService.categoryDelete(categoryRequest);
    if (categoryResponse.errorCode === 0) {
      return categoryResponse;
    } else {
      return categoryResponse;
    }
  };

  reloadDataAfterExecute = (
    catalogues,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedCatalogueList = [];
    if (type === CrudlStatus.CREATE) {
      updatedCatalogueList = this.reloadAfterCreate(
        catalogues,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedCatalogueList = this.reloadAfterUpdate(
        catalogues,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedCatalogueList = this.reloadAfterDelete(
        catalogues,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("catalogueList", updatedCatalogueList);
  };

  reloadAfterCreate = (catalogueList, apiResponse, externalStateValues) => {
    if (catalogueList === undefined || catalogueList === null) {
      catalogueList = [];
    }
    var catalogueBean = externalStateValues.catalogueBean;
    catalogueBean.id = apiResponse.id;
    catalogueBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    catalogueList.push(catalogueBean);

    return catalogueList;
  };

  reloadAfterUpdate = (catalogueList, apiResponse, externalStateValues) => {
    var i = 0;
    catalogueList.forEach(e => {
      if (apiResponse.id === e.id) {
        catalogueList[i] = externalStateValues.catalogueBean;
        catalogueList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return catalogueList;
  };

  reloadAfterDelete = (catalogueList, apiResponse, externalStateValues) => {
    var i = 0;
    catalogueList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        catalogueList.splice(i, 1);
      }
      i++;
    });

    return catalogueList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let catalogueRequest = stateVariables.catalogueBean;
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createCatalogue(catalogueRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateCatalogue(catalogueRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteCatalogue(catalogueRequest);
    }
  };

  createCatalogue = async (catalogueRequest, stateVariables) => {
    catalogueRequest.codeTag = this.codeTag;
    catalogueRequest.userId = this.userId;

    let catalogueResponse = await ApiService.catalogueCreate(catalogueRequest);
    if (catalogueResponse.errorCode === 0) {
      catalogueRequest.categoryList.forEach(async element => {
        element.catalogueId = catalogueResponse.id;
        if (Format.isNotNull(element.crudlStatus)) {
          if (element.crudlStatus === CrudlStatus.UPDATE) {
            // DO NOTHING
          }
          if (element.crudlStatus === CrudlStatus.CREATE) {
            await this.createCategory(element);
          }
          if (element.crudlStatus === CrudlStatus.DELETE) {
            // DO NOTHING
          }
        }
      });

      this.showSuccess("Catalogue", CrudlStatus.CREATE);
    } else {
      this.showError("Catalogue", CrudlStatus.CREATE);
    }

    return catalogueResponse;
  };

  deleteCatalogue = async catalogueRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = catalogueRequest.id;
    request.lastUpdatedDateTime = catalogueRequest.lastUpdatedDateTime;

    let catalogueResponse = await ApiService.catalogueDelete(request);
    if (catalogueResponse.errorCode === 0) {
      this.showSuccess("Catalogue", CrudlStatus.DELETE);
    } else {
      this.showError("Catalogue", CrudlStatus.DELETE);
    }

    return catalogueResponse;
  };

  updateCatalogue = async (catalogueRequest, stateVariables) => {
    catalogueRequest.codeTag = this.codeTag;
    catalogueRequest.userId = this.userId;

    let catalogueResponse = await ApiService.catalogueUpdate(catalogueRequest);
    if (catalogueResponse.errorCode === 0) {
      catalogueRequest.categoryList.forEach(async element => {
        element.catalogueId = catalogueResponse.id;
        if (Format.isNotNull(element.crudlStatus)) {
          if (element.crudlStatus === CrudlStatus.UPDATE) {
            await this.updateCategory(element);
          }
          if (element.crudlStatus === CrudlStatus.CREATE) {
            console.log("Creating Category");
            await this.createCategory(element);
          }
        }
      });

      stateVariables.deletedCategoryList.forEach(async element => {
        element.catalogueId = catalogueResponse.id;

        await this.deleteCategory(element);
      });

      this.showSuccess("Catalogue", CrudlStatus.UPDATE);
    } else {
      this.showError("Catalogue", CrudlStatus.UPDATE);
    }

    return catalogueResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/CatalogueViewModel.js